import { useState } from 'react';
import { api } from '../shared/api.ts';
import { useAuth } from '../shared/auth.tsx';
import { fmtDateTime } from '../shared/format.ts';
import { Link } from '../shared/router.tsx';
import { Card, ErrorBox, Spinner, useLoad } from '../shared/ui.tsx';

export function AuditLog() {
  const { can } = useAuth();
  const [action, setAction] = useState('');
  const [q, setQ] = useState('');
  const r = useLoad(() => api.get(`/api/audit?limit=300${q ? `&action=${encodeURIComponent(q)}` : ''}`), [q]);
  return (
    <div className="stack">
      <div className="row between">
        <h1>Audit log</h1>
        {can('admin.users') && (
          <a className="btn sm" href={`/api/audit/export.csv?limit=5000${q ? `&action=${encodeURIComponent(q)}` : ''}`}>
            Export CSV
          </a>
        )}
      </div>
      <form
        className="row gap"
        onSubmit={(e) => {
          e.preventDefault();
          setQ(action);
        }}
      >
        <input placeholder="Filter by action prefix, e.g. custody. or affidavit.signed" value={action} onChange={(e) => setAction(e.target.value)} className="grow" />
        <button className="btn">Filter</button>
      </form>
      <Card>
        {r.loading && <Spinner />}
        <ErrorBox error={r.error} />
        <div className="table-wrap">
          <table className="table small">
            <thead>
              <tr>
                <th>When</th>
                <th>Who</th>
                <th>Action</th>
                <th>Paper</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {r.data?.events.map((e: any) => (
                <tr key={e.id}>
                  <td>{fmtDateTime(e.at)}</td>
                  <td>
                    {e.actor ?? 'system'} <span className="muted">{e.actor_role}</span>
                  </td>
                  <td className="mono">{e.action}</td>
                  <td>{e.paper_id ? <Link to={`/papers/${e.paper_id}`}>{e.civilos_number}</Link> : ''}</td>
                  <td className="muted mono wrap-any">{Object.keys(e.details ?? {}).length ? JSON.stringify(e.details) : ''}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
